import React, { useState, useEffect } from "react";
import HelpAndSupport from "../../../components/helpAndSupport/helpAndSupport";
import APP_CONSTANTS from "../../../helper/constant/APP_CONSTANTS";

// STYLES coming from _login.scss

export default function ({
  loader,
  LoadingOutlined,
  dispatchLogin,
  supportData,
}) {
  const [showHelp, setShowHelp] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    let flag = 0;
    if (supportData.status === "201") {
      flag = 1;
      setShowHelp(false);
      setSuccess(true);
    }
    // console.log("useEffect Flag ", flag);
    return () => {
      // console.log("clean up, flag ", flag);
      if (flag === 1) {
        dispatchLogin({ type: "RESET_SUPPORT_DATA" });
      }
    };
  });
  return (
    <>
      <span className="TorC-msg">
        &copy; 2017-{new Date().getFullYear()} MyMemoryMentor Inc. All Rights
        Reserved
      </span>
      <p className="contact-help-container">
        <a
          rel="noreferrer noopener"
          target="_blank"
          href={APP_CONSTANTS.TERMS_OF_SERVICES_URL}
          className="toc"
        >
          Terms of Service
        </a>

        <a
          rel="noreferrer noopener"
          target="_blank"
          href={APP_CONSTANTS.PRIVACY_POLICY_URL}
        >
          Privacy Policy
        </a>

        <a
          rel="noreferrer noopener"
          target="_blank"
          href={APP_CONSTANTS.CONTACT_US_URL}
        >
          Contact us
        </a>

        <a
          rel="noreferrer noopener"
          href=""
          onClick={(e) => {
            e.preventDefault();
            setShowHelp(true);
          }}
        >
          {"Help & Support"}
        </a>
      </p>
      <HelpAndSupport
        showHelp={showHelp}
        setShowHelp={setShowHelp}
        success={success}
        setSuccess={setSuccess}
        loader={loader}
        LoadingOutlined={LoadingOutlined}
        dispatchLogin={dispatchLogin}
      />
    </>
  );
}
